let merge = require('merge-recursive');

/**
 * @param {string} appName
 * @constructor
 */
export let Customization = function (appName) {
  let defaultCustomization = {
    onConfigReady: (config) => null,

    onBarReady: (bar) => true,
    onBarShown: (bar) => null,
    barTemplate: '',

    onBadgeReady: (badge) => true,
    onBadgeShown: (badge) => null,
    badgeTemplate: '',

    onPopupReady: (popup) => null,
    onPopupShown: (popup) => null,
    popupTemplate: '',

    onListenerReady: (listener) => null,

    onFieldReady: (field) => true,
    onFieldShown: (field) => null,
    fieldTemplate: '',
    onTotalRecalculated: (field) => null,

    tabsTemplate: '',

    tabInfoTemplate: '',
    tabInfoSignup: '',
    tabInfoPurchaseTemplate: '',

    tabTermsTemplate: '',

    tabStatsTemplate: '',

    tabHistoryTemplate: '',
    tabHistoryTemplateRows: '',
    tabHistoryTemplatePager: '',
    tabHistoryEmpty: '',
    tabHistoryChargeExpired: '',
    tabHistoryChargePurchase: '',


    onWidgetReady: (widget) => true,
    onWidgetShown: (widget) => null,
    widgetTemplate: '',
    widgetDelay: 1500,
    widgetVariantsUpdateDelay: 0,
    widgetVariantsElementMainSelector: '',
    widgetVariantsElementOptionsSelector: '',
    customerAccountHeader: '',
    showProductPageWidgetAlways: false,

    rewardNames: {
      purchase: '',
      share: '',
      referral: '',
      register: '',
      visits: '',
      dob: '',
      manual: ''
    }
  };

  let isCustomizationSet = (
      typeof(Spurit) !== 'undefined' &&
      typeof(Spurit[appName]) !== 'undefined' &&
      typeof(Spurit[appName].customization) !== 'undefined'
  );
  let customization = defaultCustomization;
  if (isCustomizationSet) {
    customization = merge.recursive(customization, Spurit[appName].customization);
  }
  for (let key in customization) {
    this[key] = customization[key];
  }
};